import {css} from 'lit';

export const searchFilterNavStyle = css` 
    :host {
    
    }
    
    sbk-tab-menu {
        display: flex;
        justify-content: center;
        gap: var(--sbkCoreSpacingMd);
        margin: var(--sbkCoreSpacingXl) 0;
    }
`;
